<template>
  <div>
    <!-- FILTER START -->
    <div class="row align-items-center justify-content-end">
      <div class="d-flex col-md-4 relative">
        <input type="text" class="form-control" v-model="filter.search" placeholder="Search" />
        <button type="button" style="
            background: transparent;
            outline: none;
            border: none;
            position: absolute;
            right: 1rem;
            top: 0.375rem;
          " @click="fetchData">
          <svg width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
              d="M9.89279 5.44689C9.89279 7.8907 7.91169 9.8718 5.46788 9.8718C3.02407 9.8718 1.04297 7.8907 1.04297 5.44689C1.04297 3.00307 3.02407 1.02197 5.46788 1.02197C7.91169 1.02197 9.89279 3.00307 9.89279 5.44689Z"
              stroke="#9D9D9D" stroke-linecap="round" stroke-linejoin="round" />
            <path d="M10.9998 10.9778L8.59375 8.57178" stroke="#9D9D9D" stroke-linecap="round"
              stroke-linejoin="round" />
          </svg>
        </button>
      </div>
      <button v-if="isSuperAdmin" type="button" class="btn btn-primary" style="height: 32px" @click="modal.new = true">
        New User
      </button>
    </div>
    <!-- FILTER END -->

    <div class="bg-white shadow box-content mt-5">
      <div class="mt-3 scan-history-table-wrapper">
        <!-- Loading State -->
        <div v-if="tableLoading" class="text-center mt-3 mb-3">
          <h4>Loading...</h4>
        </div>

        <!-- Table -->
        <div v-else style="overflow-x: auto; overflow-y: hidden">
          <table class="table scan-history-table" style="margin: 0">
            <thead>
              <tr>
                <th>Username</th>
                <th>Type</th>
                <th>Status</th>
                <th>Device Lock</th>
                <th>Last Login</th>
                <th v-if="isSuperAdmin">Action</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(row, index) in tableData" :key="index">
                <td>{{ row.username || 'N/A' }}</td>
                <td>{{ row.type || 'N/A' }}</td>
                <td :style="getStatusStyle(row.status)">{{ row.status.charAt(0).toUpperCase() + row.status.slice(1).toLowerCase() || 'N/A' }}</td>
                <td :style="getDeviceLockStyle(row.device_uuid)">{{ row.device_uuid || 'N/A' }}</td>
                <td>{{ row.last_login || 'N/A' }}</td>
                <td v-if="isSuperAdmin" style="text-align: left">
                  <button type="button" title="Edit" @click="editUser(row)"
                    style="background: transparent; border: none; padding: 0; cursor: pointer; margin: 0 4px;">
                    <img src="@/assets/tabler_edit.svg" alt="Edit" style="width: 24px; height: 24px;" />
                  </button>
                  <button v-if="row.device_uuid === 'SET'" type="button" title="Reset Device"
                    @click="resetDeviceUUID(row.id)"
                    style="background: transparent; border: none; padding: 0; cursor: pointer; margin: 0 4px;">
                    <img src="@/assets/mdi_user-off-outline.svg" alt="Reset Device"
                      style="width: 24px; height: 24px;" />
                  </button>
                  <button type="button" title="Delete" @click="deleteUser(row.id)"
                    style="background: transparent; border: none; padding: 0; cursor: pointer; margin: 0 4px;">
                    <img src="@/assets/mingcute_delete-line.svg" alt="Delete" style="width: 24px; height: 24px;" />
                  </button>
                </td>
              </tr>
              <tr v-if="!tableLoading && tableData.length === 0">
                <td :colspan="isSuperAdmin ? 6 : 5" class="text-center">No data available</td>
              </tr>
            </tbody>
          </table>
        </div>

        <!-- Pagination -->
        <div class="row mt-3" v-if="!tableLoading && (tableData.length > 0 || maxPage > 0)">
          <div class="col-12 d-flex align-items-center justify-content-between flex-wrap">
            <div class="d-flex align-items-center">
              <label for="view-items-per-page"
                style="margin-right: 8px; margin-bottom: 0; color: #a3a4a6; font-size: 14px;">View</label>
              <select id="view-items-per-page" v-model="limitPerPage" @change="onLimitChange"
                class="form-control form-control-sm" style="width: auto; display: inline-block; padding: 4px 8px;">
                <option :value="10">10</option>
                <option :value="25">25</option>
                <option :value="50">50</option>
                <option :value="100">100</option>
              </select>
              <span style="margin-left: 8px; color: #a3a4a6; font-size: 14px;">items per page</span>
            </div>
            <div class="d-flex align-items-center flex-wrap">
              <p class="mt-2 mb-2" style="color: #a3a4a6; margin-right: 20px; margin-bottom: 0;">
                Showing {{ (currentPage - 1) * limitPerPage + 1 }}-{{ currentPage * limitPerPage < total ? currentPage *
                  limitPerPage : total }} of {{ total > 0 ? total : '?' }} Items
              </p>
              <nav class="pagination-minimal">
                <ul class="pagination" style="margin: 0; flex-wrap: wrap;">
                  <li class="page-item" :class="{ disabled: currentPage <= 1 }"
                    @click.stop.prevent="changePage('prev')">
                    <a class="page-link" href="javascript:void(0)">&lsaquo;</a>
                  </li>
                  <li class="page-item" :class="{ disabled: currentPage >= maxPage && !hasMoreData }"
                    @click.stop.prevent="changePage('next')">
                    <a class="page-link" href="javascript:void(0)">&rsaquo;</a>
                  </li>
                </ul>
              </nav>
            </div>
          </div>
        </div>
      </div>
    </div>

    <cu-user-management v-if="modal.new || modal.edit" :data="modal.edit ? modal.editData : null"
      api_new="/api/settings/userMaindealerRegister" api_edit="/api/settings/updateUserMaindealer"
      form_type="User Penindakan" :is_company_exist="false" @refreshData="fetchData" @closeModal="
        modal.new = false;
      modal.edit = false;
      "></cu-user-management>
  </div>
</template>

<script>
import qs from "qs";
import cuUserManagement from "./children/CUUserManagement";

export default {
  metaInfo: {
    title: "Penindakan App User Management",
  },
  data() {
    return {
      user: this.$store.getters.currentUser,
      modal: {
        new: false,
        edit: false,
        editData: false,
      },
      filter: {
        search: "",
      },
      // Table data
      tableData: [],
      tableLoading: false,
      currentPage: 1,
      maxPage: 1,
      total: 0,
      limitPerPage: 10,
      // Debounce timer
      fetchDataTimer: null,
    };
  },
  components: {
    cuUserManagement,
  },
  computed: {
    hasMoreData() {
      // If we got a full page of data, there's likely more
      return this.tableData.length === this.limitPerPage;
    },
    isSuperAdmin() {
      return this.user && this.user.super_admin === 1;
    },
  },
  mounted() {
    this.fetchData();
  },
  beforeDestroy() {
    if (this.fetchDataTimer) {
      clearTimeout(this.fetchDataTimer);
    }
  },
  watch: {
    "filter.search": function (newVal, oldVal) {
      if (newVal !== oldVal) {
        this.currentPage = 1; // Reset to first page
        this.fetchData();
      }
    },
  },
  methods: {
    async fetchData() {
      // Clear existing timer to debounce rapid calls
      if (this.fetchDataTimer) {
        clearTimeout(this.fetchDataTimer);
      }

      this.fetchDataTimer = setTimeout(() => {
        this.performFetchData();
      }, 300); // 300ms debounce
    },
    async performFetchData() {
      this.tableLoading = true;

      try {
        // Build query params
        let queryParams = {
          pagination: true,
          limit: this.limitPerPage,
          page: this.currentPage,
          order: "DESC",
          by: "id",
        };

        // Add search filter
        if (this.filter.search && this.filter.search.trim()) {
          queryParams.search = this.filter.search.trim();
        }

        const url = `/api/settings/userMaindealerList?${qs.stringify(queryParams, {
          skipNulls: true,
          arrayFormat: "comma",
        })}`;

        const resp = await this.$http.get(url);

        const rawData = resp.data.data || [];

        // Check for pagination meta in various possible locations
        const meta = resp.data.meta || resp.data.pagination || resp.data || {};

        // Process data - transform device_uuid and last_login
        const processedData = rawData.map((item) => ({
          ...item,
          status: item.status.charAt(0).toUpperCase() + item.status.slice(1).toLowerCase(),
          device_uuid: item.device_uuid ? 'SET' : 'NONE',
          last_login: item.last_login ? item.last_login : 'N/A'
        }));

        // Handle pagination metadata - check multiple possible field names
        const currentPage = meta.currentPage || meta.current_page || meta.page || this.currentPage || 1;
        let total = meta.total || meta.totalItems || meta.total_count || meta.totalRecords || meta.count || 0;
        let lastPage = meta.lastPage || meta.last_page || meta.totalPages || meta.total_pages || meta.maxPage || 0;

        // If total is 0 but we have data, we need to estimate
        // If we got a full page of data, there might be more pages
        if (total === 0) {
          if (processedData.length === this.limitPerPage) {
            // We got a full page, so there's likely more data
            total = this.currentPage * this.limitPerPage;
            lastPage = this.currentPage + 1; // At least one more page exists
          } else if (processedData.length > 0) {
            // We got partial data, so this is likely the last page
            total = (this.currentPage - 1) * this.limitPerPage + processedData.length;
            lastPage = this.currentPage;
          } else {
            // No data
            total = 0;
            lastPage = 1;
          }
        } else if (total > 0) {
          // We have total, calculate lastPage if not provided
          if (!lastPage || lastPage === 0) {
            lastPage = Math.ceil(total / this.limitPerPage);
          }
        }

        // Ensure lastPage is at least 1
        lastPage = Math.max(1, lastPage);

        // If we got a full page and we're on the last calculated page, there might be more
        if (processedData.length === this.limitPerPage && this.currentPage >= lastPage) {
          lastPage = this.currentPage + 1;
        }

        // Update pagination state
        this.$set(this, 'tableData', processedData);
        this.$set(this, 'currentPage', Number.parseInt(currentPage));
        this.$set(this, 'maxPage', Number.parseInt(lastPage));
        this.$set(this, 'total', Number.parseInt(total));
      } catch (err) {
        console.log('Error fetching user data:', err);
        this.$set(this, 'tableData', []);
        this.$set(this, 'currentPage', 1);
        this.$set(this, 'maxPage', 1);
        this.$set(this, 'total', 0);
      } finally {
        this.tableLoading = false;
      }
    },
    onLimitChange() {
      this.$set(this, 'currentPage', 1);
      this.fetchData();
    },
    changePage(opt) {
      if (this.tableLoading) {
        return;
      }

      let newPage = this.currentPage;

      if (opt === 'prev') {
        newPage = Math.max(1, this.currentPage - 1);
      } else if (opt === 'next') {
        // Allow going to next page if we have more data or if we're not at maxPage
        if (this.hasMoreData || this.currentPage < this.maxPage) {
          newPage = this.currentPage + 1;
        } else {
          return; // Can't go to next page
        }
      }

      if (newPage !== this.currentPage && newPage >= 1) {
        this.$set(this, 'currentPage', newPage);
        this.fetchData();
      }
    },
    getStatusStyle(status) {
      const styles = {
        Active: "color:#34CE4C; font-weight:bold",
        Inactive: "color:red; font-weight:bold",
      };
      return styles[status] || "";
    },
    getDeviceLockStyle(deviceUuid) {
      const styles = {
        SET: "color:blue; font-weight:bold",
        NONE: "color:grey; font-weight:bold",
      };
      return styles[deviceUuid] || "";
    },
    editUser(user) {
      this.modal.editData = user;
      this.modal.edit = true;
    },
    deleteUser(userId) {
      this.$swal
        .fire({
          title: "Are you sure?",
          text: "Deleting a user is permanent and cannot be undone — proceed with caution",
          icon: "warning",
          showCancelButton: true,
          confirmButtonColor: "#D33",
          cancelButtonColor: "#1B698E",
          confirmButtonText: "Delete",
          customClass: "custom",
          didOpen: () => {
            // Get the confirm button and add your class
            const confirmButton = document.querySelector('.swal2-confirm');
            const cancelButton = document.querySelector('.swal2-cancel');
            if (confirmButton) {
              confirmButton.style.marginLeft = '20px';
              confirmButton.style.padding = '12px 45px';
            }

            if (cancelButton) {
              confirmButton.style.marginRight = '20px';
              cancelButton.style.padding = '12px 45px';
            }
          }
        })
        .then((result) => {
          if (result.value) {
            this.$http
              .delete("/api/settings/deleteUserMaindealer?id=" + userId)
              .then((resp) => {
                this.$swal.fire({
                  title: "Success!",
                  icon: "success",
                  type: "success",
                  text: `User has been successfully deleted`,
                });
                this.fetchData();
              })
              .catch((error) => {
                console.log(
                  "%cerror PenindakanAppUM.vue line:206 ",
                  "color: red; display: block; width: 100%;",
                  error
                );
                this.$swal.fire({
                  title: "Error!",
                  icon: "error",
                  type: "error",
                  text: (error.response && error.response.data && error.response.data.message) || "An error occurred",
                });
              });
          }
        });
    },
    resetDeviceUUID(userId) {
      this.$swal
        .fire({
          title: "Are you sure?",
          text: "You are going to open the device lock for this account",
          icon: "warning",
          showCancelButton: true,
          confirmButtonColor: "#D33",
          cancelButtonColor: "#1B698E",
          confirmButtonText: "Remove Lock",
          customClass: "custom",
        })
        .then((result) => {
          if (result.value) {
            this.$http
              .put("/api/settings/updateUserMaindealer", {
                id: userId,
                device_uuid: -1,
              })
              .then((resp) => {
                this.$swal.fire({
                  title: "Success!",
                  icon: "success",
                  type: "success",
                  text: `Account's device lock has successfully been lifted!`,
                });
                this.fetchData();
              })
              .catch((error) => {
                console.log(
                  "%cerror PenindakanAppUM.vue line:253 ",
                  "color: red; display: block; width: 100%;",
                  error
                );
                this.$swal.fire({
                  title: "Error!",
                  icon: "error",
                  type: "error",
                  text: (error.response && error.response.data && error.response.data.message) || "An error occurred",
                });
              });
          }
        });
    },
  },
};
</script>

<style scoped>
.box-content {
  padding: 20px;
  border-radius: 10px;
}

/* Scan History Table Styles */
.scan-history-table-wrapper .scan-history-table {
  border-collapse: separate;
  border-spacing: 0;
  border: none !important;
}

.scan-history-table-wrapper .scan-history-table tbody tr {
  background-color: #FFFFFF !important;
  border-top: none !important;
  border-bottom: none !important;
}

.scan-history-table-wrapper .scan-history-table.table-striped tbody tr {
  background-color: #FFFFFF !important;
  border-top: none !important;
  border-bottom: none !important;
}

.scan-history-table-wrapper .scan-history-table.table-striped tbody tr:nth-of-type(odd) {
  background-color: #FFFFFF !important;
}

.scan-history-table-wrapper .scan-history-table thead th {
  color: #9D9D9D;
  text-align: left;
  vertical-align: middle;
  border-bottom: 1px solid #dee2e6;
  border-top: none !important;
}

.scan-history-table-wrapper .scan-history-table thead th:first-child {
  border-left: none !important;
}

.scan-history-table-wrapper .scan-history-table thead th:last-child {
  border-right: none !important;
}

.scan-history-table-wrapper .scan-history-table tbody td {
  color: #4B4B4B;
  text-align: left;
  vertical-align: middle;
  background-color: #FFFFFF !important;
  border-top: none !important;
  border-bottom: none !important;
}

.scan-history-table-wrapper .scan-history-table tbody td:first-child {
  border-left: none !important;
}

.scan-history-table-wrapper .scan-history-table tbody td:last-child {
  border-right: none !important;
}

.scan-history-table-wrapper .scan-history-table tbody tr:first-child td {
  border-top: none !important;
}

.scan-history-table-wrapper .scan-history-table tbody tr:last-child td {
  border-bottom: none !important;
}

/* Pagination Styles - Minimalist */
.scan-history-table-wrapper .pagination-minimal .pagination {
  margin-bottom: 0;
}

.scan-history-table-wrapper .pagination-minimal .page-item {
  margin: 0 2px;
}

.scan-history-table-wrapper .pagination-minimal .page-item .page-link {
  background: transparent !important;
  border: none !important;
  color: #4B4B4B;
  padding: 4px 8px;
  cursor: pointer;
  user-select: none;
  font-size: 14px;
}

.scan-history-table-wrapper .pagination-minimal .page-item:not(.disabled):hover .page-link {
  background: transparent !important;
  color: #007bff;
}

.scan-history-table-wrapper .pagination-minimal .page-item.disabled .page-link {
  cursor: not-allowed;
  pointer-events: none;
  opacity: 0.4;
  color: #9D9D9D !important;
}

.scan-history-table-wrapper .pagination-minimal .page-item.active .page-link {
  background: transparent !important;
  border: none !important;
  color: #007bff !important;
  font-weight: 600;
}

.scan-history-table-wrapper .pagination-minimal .page-item.active .page-link:hover {
  background: transparent !important;
  color: #007bff !important;
}
</style>
<style>
.custom .swal2-styled.swal2-cancel {
  order: -1;
}
</style>